import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import TrainingSettingForm from './TrainingSettingForm';

/** Legacy full-page route for training settings (e.g. deep links from CourseDetail). */
const TrainingSetting = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { trainingDetails } = location.state || {};
  const [missingDetailsAlert, setMissingDetailsAlert] = useState(!trainingDetails);

  const handleDismiss = () => {
    navigate('/Portal/Instructor/TrainingSection');
  };

  const handleCloseMissingDetailsAlert = () => {
    setMissingDetailsAlert(false);
    handleDismiss();
  };

  if (!trainingDetails) {
    return (
      <Dialog open={missingDetailsAlert} onClose={handleCloseMissingDetailsAlert}>
        <DialogTitle>Select Training</DialogTitle>
        <DialogContent>
          <DialogContentText>Please select a training to continue.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMissingDetailsAlert} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          maxWidth: '97%',
          margin: '0 auto',
          background: 'white',
          padding: '20px',
          borderRadius: '10px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
        }}
      >
        <TrainingSettingForm
          key={trainingDetails.trainingId}
          trainingDetails={trainingDetails}
          onDismiss={handleDismiss}
        />
      </div>
    </div>
  );
};

export default TrainingSetting;
